define.alias("shared/components/shared/media-items/modal-display", "settings/components/shared/media-items/modal-display");